module.exports = __webpack_public_path__ + "img/10天通道.bd9fee98.png";